module.exports = __webpack_public_path__ + "img/101-el-05.prt.c1f598f8.jpg";